import { http } from "@/http";

export default {
  getDashboard(params) {
    return http.get("/api/v1/affiliate/dashboard", { params });
  },
  getRides(params) {
    return http.get("/api/v1/affiliate/rides", { params });
  },
  changePassword(data) {
    return http.put("/api/v1/affiliate/password", data);
  },
};
